import { EventEmitter } from 'expo';

export enum NAVIGATION_EVENT_TYPES {
  SELECT_CHANNEL = 'SELECT_CHANNEL',
}

export type NavigationEventsMap = {
  [NAVIGATION_EVENT_TYPES.SELECT_CHANNEL]: (args: { channelId: string }) => void;
};

export const navigationEvents = new EventEmitter<NavigationEventsMap>();
